module.exports = __webpack_public_path__ + "static/media/check.6d24fb8c.svg";